
import { guessHistoryColor } from '@/assets/colors'
import { defineComponent } from 'vue'
import LetterTile from './LetterTile.vue'

export default defineComponent({
    components: {
        LetterTile,
    },
    props: {
        word: {
            required: true,
            type: String,
        },
        guessIndex: {
            required: true,
            type: Number,
        }
    },
    computed: {
        color() {
            return guessHistoryColor;
        },
    }
})
